.root {
  display: flex;
  flex-direction: column;
}

.nav {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 1rem;
  gap: 1rem;
}

.navLinks {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.vr {
  align-self: stretch;
  border: none;
  border-left: 1px solid #dee2e6;
  margin: 0;
}

.content {
  flex-grow: 1;
}
